import { Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import TextInputDisable from "@saleor/components/TextInputDisable/TextInputDisable";
import useSales from "@saleor/createOrderDomestic/views/CreateOrderView/useSales";
import { makeStyles } from "@saleor/macaw-ui";
import { FormikProps } from "formik";
import React from "react";
import { useIntl } from "react-intl";

interface SalesTabProps {
  data?: any;
  formik: FormikProps<any>;
  salesOrgCode?: string;
  orderTypeDesc?: string;
}

const useStyles = makeStyles(
  theme => ({
    boxBackground: {
      borderRadius: 4,
      background: theme.palette.background.default,
      padding: "9px 16px",
      height: 40
    },
    selectField: {
      height: 40
    },
    gridRow: {
      marginBottom: 15
    }
  }),
  { name: "SalesTab" }
);

const SalesTab: React.FC<SalesTabProps> = props => {
  const { formik, salesOrgCode, orderTypeDesc } = props;
  const classes = useStyles();
  const intl = useIntl();

  const [
    saleGroupChoices,
    divisionChoices,
    saleOfficeChoices,
    distributionChannelChoices,
    saleOrganizationChoices
  ] = useSales(salesOrgCode);

  return (
    <Grid container>
      <Grid item xs={12} md={4}>
        <Grid
          container
          spacing={2}
          alignItems={"center"}
          className={classes.gridRow}
        >
          <Grid item md={4}>
            <MyTypography variant={"subtitle3"}>
              {intl.formatMessage({ defaultMessage: "Order Type" })}
            </MyTypography>
          </Grid>
          <Grid item md={8}>
            <TextInputDisable value={orderTypeDesc} />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          alignItems={"center"}
          className={classes.gridRow}
        >
          <Grid item md={4}>
            <MyTypography variant={"subtitle3"}>
              {intl.formatMessage({ defaultMessage: "Sales Organization" })}
            </MyTypography>
          </Grid>
          <Grid item md={8}>
            <SingleSelectField
              disabled
              value={formik.values.salesOrganization}
              name={"salesOrganization"}
              id={"salesOrganization"}
              choices={saleOrganizationChoices}
              onChange={formik.handleChange}
              className={classes.selectField}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          alignItems={"center"}
          className={classes.gridRow}
        >
          <Grid item md={4}>
            <MyTypography variant={"subtitle3"}>
              {intl.formatMessage({ defaultMessage: "Distribution Channel" })}
            </MyTypography>
          </Grid>
          <Grid item md={8}>
            <SingleSelectField
              disabled
              name={"distributionChannel"}
              id="distributionChannel"
              value={formik.values.distributionChannel}
              choices={distributionChannelChoices}
              onChange={formik.handleChange}
              className={classes.selectField}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          alignItems={"center"}
          className={classes.gridRow}
        >
          <Grid item md={4}>
            <MyTypography variant={"subtitle3"}>
              {intl.formatMessage({ defaultMessage: "Division" })}
            </MyTypography>
          </Grid>
          <Grid item md={8}>
            <SingleSelectField
              disabled
              name={"division"}
              id="division"
              value={formik.values.division}
              choices={divisionChoices}
              onChange={formik.handleChange}
              className={classes.selectField}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          alignItems={"center"}
          className={classes.gridRow}
        >
          <Grid item md={4}>
            <MyTypography variant={"subtitle3"}>
              {intl.formatMessage({ defaultMessage: "Sales Group" })}
            </MyTypography>
          </Grid>
          <Grid item md={8}>
            <SingleSelectField
              name={"salesGroup"}
              id="salesGroup"
              value={formik.values.salesGroup}
              choices={saleGroupChoices}
              onChange={formik.handleChange}
              className={classes.selectField}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems={"center"}>
          <Grid item md={4}>
            <MyTypography variant={"subtitle3"}>
              {intl.formatMessage({ defaultMessage: "Sales Office" })}
            </MyTypography>
          </Grid>
          <Grid item md={8}>
            <SingleSelectField
              value={formik.values.salesOffice}
              choices={saleOfficeChoices}
              onChange={formik.handleChange}
              name={"salesOffice"}
              id="salesOffice"
              className={classes.selectField}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={7} />
    </Grid>
  );
};

export default SalesTab;
